module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/font/notokr-regular.woff
// module id = QZXI
// module chunks = 0